import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import { ImportList, WebformCreate, DataProviderCreate, WebForms, DataProviders, AddImport, DataMapping } from 'pages';

const PARENT_NAME = "integrations_data_import";

export const INTEGRATIONS_SETTINGS = [
    {
        path: `web-forms`,
        icon: 'fas fa-file-alt',
        header: 'Web Forms',
        description: 'Add, preview, and customize your Contact Forms.',
        page: WebForms,
        type: `${PARENT_NAME}.web_forms`,
        disabled: true,
        userPermission: USER_PERMISSIONS.WEB_FORMS_VIEW
    },
    {
        path: `web-forms/create`,
        icon: 'fas fa-file-alt',
        header: 'Create Web Form',
        description: 'Add, and customize your Contact Form.',
        page: WebformCreate,
        exclude: true,
        parent: {
            path: 'web-forms',
            name: 'Web Forms'
        },
        disabled: true,
        userPermission: USER_PERMISSIONS.WEB_FORMS_ADD
    },
    {
        path: `web-forms/edit/:form_id`,
        icon: 'fas fa-file-alt',
        header: 'Edit Web Form',
        description: 'Edit your Contact Form.',
        page: WebformCreate,
        exclude: true,
        parent: {
            path: 'web-forms',
            name: 'Web Forms'
        },
        disabled: true,
        userPermission: USER_PERMISSIONS.WEB_FORMS_EDIT
    },
    {
        path: `import-data`,
        icon: 'fas fa-file-import',
        header: 'Import data',
        description: 'Import Contacts or Leads in bulk as .CSV.',
        page: ImportList,
        type: `${PARENT_NAME}.import_data`,
        userPermission: USER_PERMISSIONS.IMPORT_DATA_VIEW
    },
    {
        path: `data-providers`,
        icon: 'fa-sharp fa-solid fa-database',
        header: 'Data Providers',
        description: 'Add providers and organize by Source Type and Secondary Source.',
        page: DataProviders,
        type: `${PARENT_NAME}.data_providers`,
        userPermission: USER_PERMISSIONS.DATA_PROVIDERS_VIEW
    },
    {
        path: `data-providers/create`,
        icon: 'fab fa-sourcetree',
        header: 'Create Data Providers',
        description: 'Update the description when you get here :).',
        page: DataProviderCreate,
        exclude: true,
        parent: {
            path: 'data-providers',
            name: 'Data Providers'
        },
        userPermission: USER_PERMISSIONS.DATA_PROVIDERS_ADD
    },
    {
        path: 'import-data/setup',
        page: AddImport,
        exclude: true,
        parent: {
            path: 'import-data',
            name: 'Import Data'
        },
        header: 'Add New Import',
        userPermission: USER_PERMISSIONS.IMPORT_DATA_ADD,
        productPermission: PRODUCT_PERMISSIONS.RECORDS
    },
    //post
    {
        path: 'data-mapping/post/:id',
        page: DataMapping,
        exclude: true,
        parent: {
            path: 'post-parsing-template',
            name: 'Parse Post',
            pathId: true, //Add if, breadcrumb path needs to pass :id to return to page
        },
        header: 'Data Mapping'
    },
    {
        path: 'data-mapping/post/edit/:id',
        page: DataMapping,
        exclude: true,
        parent: {
            path: 'post-parsing-template',
            name: 'Parse Post',
            pathId: true, //Add if, breadcrumb path needs to pass :id to return to page
        },
        header: 'Edit Data Mapping'
    },
    //email
    {
        path: 'data-mapping/email/:id',
        page: DataMapping,
        exclude: true,
        parent: {
            path: 'email-parsing-template',
            name: 'Parse Email',
            pathId: true,
        },
        header: 'Data Mapping'
    },
    {
        path: 'data-mapping/email/edit/:id',
        page: DataMapping,
        exclude: true,
        parent: {
            path: 'email-parsing-template',
            name: 'Parse Email',
            pathId: true,
        },
        header: 'Edit Data Mapping'
    },
    {
        path: 'assignments/:id',
        page: AddImport,
        exclude: true,
        parent: {
            path: 'data-mapping',
            name: 'Data Mapping',
            pathId: true,
        },
        header: 'Assignments'
    },
    {
        path: 'confirm/:id',
        page: AddImport,
        exclude: true,
        parent: {
            path: 'assignments',
            name: 'Assignments',
            pathId: true,
        },
        header: 'Confirm'
    }
];
